import React, { useEffect } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

export interface InlineEditRowProps {
  label: string;
  value?: string;
  mode: 'view' | 'edit';
  editableInline?: boolean;
  placeholder?: string;
  // Optional custom renderer for view mode (e.g., website icon, star row)
  renderWhenView?: (value: string | undefined) => React.ReactNode;
  // Normalize/transform value before emitting
  normalize?: (raw: string) => string | undefined;
  onPatch?: (value: string | undefined) => void;
}

const DEFAULT_PLACEHOLDERS = new Set(['待填写','待填寫','待查詢','待查询','待查询网站','待查詢網站','—']);

const InlineEditRow: React.FC<InlineEditRowProps> = ({
  label,
  value,
  mode,
  editableInline = false,
  placeholder = '',
  renderWhenView,
  normalize,
  onPatch,
}) => {
  const [editing, setEditing] = React.useState(false);
  const treatAsEmpty = (v?: string) => {
    if (v == null) return true;
    const s = String(v).trim();
    return s.length === 0 || DEFAULT_PLACEHOLDERS.has(s);
  };
  const [val, setVal] = React.useState(treatAsEmpty(value) ? '' : (value || ''));
  useEffect(() => setVal(treatAsEmpty(value) ? '' : (value || '')), [value]);

  const handleSave = () => {
    setEditing(false);
    let v = (val || '').toString().trim();
    if (normalize) {
      const nv = normalize(v);
      onPatch && onPatch(nv);
    } else {
      onPatch && onPatch(v.length ? v : undefined);
    }
  };

  return (
    <View style={styles.row}>
      <View style={styles.rowLabelWrap}><Text style={styles.rowLabel}>{label}</Text></View>
      <View style={styles.rowValueWrap}>
        {editing ? (
          <TextInput
            autoFocus
            value={val}
            onBlur={handleSave}
            onSubmitEditing={handleSave}
            onChangeText={setVal}
            style={editableInline ? styles.inlineInput : styles.input as any}
            placeholder={placeholder}
            returnKeyType="done"
          />
        ) : (
          renderWhenView && mode === 'view' && !treatAsEmpty(val) ? (
            renderWhenView(val)
          ) : (
            <TouchableOpacity onPress={() => { if (mode === 'edit') setEditing(true); }} activeOpacity={0.7}>
              {(!treatAsEmpty(val)) ? (
                <Text style={styles.rowValue}>{val}</Text>
              ) : (
                <Text style={[styles.rowValue, editableInline ? styles.inlinePlaceholder : null]}>{placeholder || '—'}</Text>
              )}
            </TouchableOpacity>
          )
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', paddingVertical: 12, borderBottomWidth: 1, borderColor: '#F3F4F6' },
  rowLabelWrap: { width: 180 },
  rowLabel: { color: '#6B7280' },
  rowValueWrap: { flex: 1, alignItems: 'flex-end' },
  rowValue: { fontWeight: '700' },
  inlinePlaceholder: { color: '#A3AAB3' },
  inlineInput: { borderBottomWidth: 1, borderBottomColor: '#E5E7EB', paddingVertical: 6, color: '#111' },
  input: { marginLeft: 8, color: '#111', borderBottomWidth: 1, borderColor: '#F3F4F6', paddingVertical: 4 },
});

export default InlineEditRow;
